import classNames from 'classnames';
import styles from './DTCDefinition.module.css';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Dropdown,
  MenuProps,
  Space,
  Checkbox,
  CheckboxProps,
  List,
  Spin,
} from 'antd';
import React, { useState, useRef, useImperativeHandle, useEffect, forwardRef } from 'react';
import Modal from '../../Modal';
import Icon from 'src/components/Icon/Icon';
import { getSearchResultFromQueryParameter } from 'src/app/query.service';
import { MODAL_STATUS } from 'src/app/constants';

interface FormData {
  [key: string]: any;
}

interface DTCDefinitionProps {
  isActive: boolean;
  onNext: (newData: { [key: string]: any }) => void;
  handleCheckbox: (decodeData: boolean) => void;
  checkboxValue: boolean;
  onBack: () => void;
  propData: FormData;
  form: any;
  queryType: any;
}

interface Module {
  id: string;
  module: string;
}
interface BaseDtc {
  id: string;
  dtcBase: string;
  dtcDescription: string;
  dtcHex: string;
}
interface FaultType {
  id: string;
  faultType: string;
  faultTypeDescription: string;
}
interface Status {
  id: string;
  status: string;
}

const DTCDefinition = forwardRef<any, DTCDefinitionProps>(
  ({ isActive, onBack, onNext, handleCheckbox, checkboxValue, propData, form, queryType }, ref) => {
    const [openModal, setOpenModal] = useState(false);
    const [inputPlaceholder, setInputPlaceholder] = useState('');
    const [isInputFocused, setIsInputFocused] = useState(false);
    const [isSmallText, setIsSmallText] = useState(false);
    const [module, setModule] = useState<FormData[]>([]);
    const [dtcBase, setBaseDtc] = useState<FormData[]>([]);
    const [faultType, setFaultType] = useState<FormData[]>([]);
    const [status, setStatus] = useState<FormData[]>([]);
    const [sourceCheck, setSourceCheck] = useState<string>('');
    const [tmpdata, setTmpData] = useState<{ [key: string]: any }>({});
    const [isLoading, setIsLoading] = useState(false);
    const [searchValue, setSearchValue] = useState<string>('');
    const [vinField, setVin] = useState<string>('');
    const [selectedFaultType, setSelectedFaultType] = useState<string[]>([]);
    const [decodeData, setDecodeData] = useState(false);
    const inputRef = useRef(null);
    const [selectedValues, setSelectedValues] = useState<{ [key: string]: any }>({
      module: [],
      dtcBase: [],
      faultType: [],
      status: [],
    });
    const onFinish = (values: any) => {};

    useImperativeHandle(ref, () => ({
      reset() {
        setSelectedValues({
          module: [],
          dtcBase: [],
          faultType: [],
          status: [],
        });
      },
    }));

    useEffect(() => {
      setDecodeData(checkboxValue);
      setSelectedValues((prevValues) => ({
        ...prevValues,
        ...propData,
      }));
    }, [propData]);

    const applyMethod = (type: string) => {
      form.setFieldValue(type, selectedValues[type].join(', '));
      setSearchValue('');
      setIsInputFocused(false);
      setIsSmallText(false);
      setTmpData([]);
      setOpenModal(false);
    };

    const handleCancel = () => {
      if (sourceCheck === 'faultType') {
        setSelectedFaultType([...(tmpdata.faultTypeDescription || [])]);
      }
      setSelectedValues((prevValues) => ({
        ...prevValues,
        [sourceCheck]: [...(tmpdata[sourceCheck] || [])],
      }));

      setSearchValue('');
      setIsInputFocused(false);
      setIsSmallText(false);
      setOpenModal(false);
      setTmpData({});
    };

    const handleInputClick = async (placeholder: string) => {
      setInputPlaceholder(placeholder);
      setOpenModal(true);
      setSearchValue('');
      setIsInputFocused(false);
      setIsSmallText(false);
      setIsLoading(true);
      form.setFieldValue('searchValues', '');

      switch (placeholder) {
        case 'Module':
          setSourceCheck('module');
          setTmpData({ module: [...selectedValues.module] });
          try {
            const searchParameter = 'module';

            const result: Module[] = await getSearchResultFromQueryParameter<Module>(
              queryType,
              searchParameter,
              selectedValues
            );
            setModule(result);
          } catch (error) {
            setIsLoading(false);
            console.error('Error fetching data:', error);
          }
          break;
        case 'Base Dtc':
          setSourceCheck('dtcBase');
          setTmpData({ dtcBase: [...selectedValues.dtcBase] });
          try {
            const searchParameter = 'dtcBase';

            const result: BaseDtc[] = await getSearchResultFromQueryParameter<BaseDtc>(
              queryType,
              searchParameter,
              selectedValues
            );
            setBaseDtc(result);
          } catch (error) {
            setIsLoading(false);
            console.error('Error fetching data:', error);
          }
          break;
        case 'Fault Type':
          setSourceCheck('faultType');
          setTmpData({
            faultType: [...selectedValues.faultType],
            faultTypeDescription: [...selectedFaultType],
          });
          try {
            const searchParameter = 'faultType';

            const result: FaultType[] = await getSearchResultFromQueryParameter<FaultType>(
              queryType,
              searchParameter,
              selectedValues
            );
            setFaultType(result);
          } catch (error) {
            setIsLoading(false);
            console.error('Error fetching data:', error);
          }
          break;
        case 'Status':
          setSourceCheck('status');
          setTmpData({ status: [...selectedValues.status] });
          try {
            const searchParameter = 'status';

            //   const result: Status[] = await getSearchResultFromQueryParameter<Status>(
            //     queryType,
            //     searchParameter,
            //     selectedValues,
            //     userId
            //   );
            const result: Status[] = [
              { id: 'status1', status: 'Test Failed' },
              { id: 'status2', status: 'Test Failed This Operationcycle' },
              { id: 'status3', status: 'Pending DTC' },
              { id: 'status4', status: 'Confirmed DTC' },
              { id: 'status5', status: 'Test Not Completed Since Last Year' },
              { id: 'status6', status: 'Test Failed Since Last Year' },
              { id: 'status7', status: 'Test Not Completed This Operation Cycle' },
              { id: 'status8', status: 'Warning Indicatior Requested' },
            ];
            setStatus(result);
          } catch (error) {
            setIsLoading(false);
            console.error('Error fetching data:', error);
          }
          break;
        default:
          break;
      }
      setIsLoading(false);
    };

    const handleModalInputFocus = () => {
      setIsInputFocused(true);
      setIsSmallText(true);
    };

    const handleModalInputBlur = () => {
      if (!searchValue) {
        setIsInputFocused(false);
        setIsSmallText(false);
      }
    };

    const handlePlaceholderClick = () => {
      // Focus the input when the placeholder is clicked
      inputRef.current.focus();
    };

    const onLinkClick = (type: string, value: string) => {
      setSelectedValues((prevValues) => ({
        ...prevValues,
        [type]: prevValues[type]?.includes(value)
          ? prevValues[type]
          : [...(prevValues[type] || []), value],
      }));
    };

    const onFaultTypeClick = (faultId: string, description: string) => {
      setSelectedValues((prevValues) => ({
        ...prevValues,
        faultType: prevValues.faultType?.includes(faultId)
          ? prevValues.faultType
          : [...(prevValues.faultType || []), faultId],
      }));
      setSelectedFaultType(
        selectedFaultType.includes(description)
          ? [...selectedFaultType]
          : [...selectedFaultType, description]
      );
    };

    const handleRemove = (type: string, itemRemove: string) => {
      setSelectedValues((prevValues) => ({
        ...prevValues,
        [type]: prevValues[type]?.filter((item: string) => item !== itemRemove),
      }));
    };

    const removeFaultType = (id: string, description: string) => {
      setSelectedValues((prevValues) => ({
        ...prevValues,
        faultType: prevValues.faultType?.filter((item: string) => item !== id),
      }));
      setSelectedFaultType([...selectedFaultType.filter((n) => n !== description)]);
    };

    // const handleNext = () => {
    //   const data = { ...selectedValues };
    //   handleCheckbox(decodeData);
    //   onNext(data);
    // };
    const handleNext = () => {
      const normalize = (value: any) => {
        if (Array.isArray(value)) return value.length === 0 ? null : value;
        return value;
      };

      const fieldsToNormalize = [
        'module',
        'dtcBase',
        'faultType',
        'status',
        'engine',
        'enginePowertrainDescription',
      ];
      const data = { ...selectedValues };

      fieldsToNormalize.forEach((field) => {
        data[field] = normalize(data[field]);
      });

      data.dtcDecodeData = decodeData;
      handleCheckbox(decodeData);
      onNext(data);
    };

    const handleInputClear = (type: string) => {
      form.setFieldValue(type, ``);
      setSelectedValues((prevValues) => ({
        ...prevValues,
        [type]: [],
      }));
    };

    const shouldShowResetButton = ['module', 'dtcBase', 'faultType', 'status'].some((key) => {
      const value = selectedValues[key];
      return Array.isArray(value) ? value.length > 0 : value !== null;
    });

    const handleReset = () => {
      form.setFieldValue('module', '');
      form.setFieldValue('dtcBase', '');
      form.setFieldValue('faultType', '');
      form.setFieldValue('status', '');
      setDecodeData(false);
      setSelectedValues({
        module: [],
        dtcBase: [],
        faultType: [],
        status: [],
      });
    };

    const moreItems: MenuProps['items'] = [
      {
        key: '1',
        label: '5',
      },
      {
        key: '2',
        label: '10',
      },
      {
        key: '3',
        label: '15',
      },
      {
        key: '4',
        label: '25',
      },
      {
        key: '4',
        label: '50',
      },
      {
        key: '4',
        label: '70',
      },
    ];

    const filteredSources = module.filter((source) =>
      source.module?.toLowerCase().includes(searchValue?.toLowerCase())
    );
    const filteredSourcesDtc = dtcBase.filter((source) =>
      source.dtcBase?.toLowerCase().includes(searchValue?.toLowerCase())
    );
    const filteredFaultType = faultType.filter((source) =>
      source.faultType?.toLowerCase().includes(searchValue?.toLowerCase())
    );
    const filteredSourcesStatus = status.filter((source) =>
      source.status?.toLowerCase().includes(searchValue?.toLowerCase())
    );
    return (
      <div className={classNames(styles.DTCDefinition)}>
        <div
          className={`
            ${styles['DTCDefinition--QueryTitle']} 
            ${isActive ? styles['DTCDefinition--active'] : styles['DTCDefinition--InActive']}
            `}
          // style={{ backgroundColor: isActive ? '#000000' : '#dcdcdc' }}
        >
          DTC Definition
          {shouldShowResetButton && (
            <div style={{ display: 'inline', float: 'right', marginRight: '30px' }}>
              <Button
                className={`${
                  isActive ? styles['DTCDefinition--Reset'] : styles['DTCDefinition--InActive']
                }`}
                type="primary"
                htmlType="submit"
                onClick={handleReset}
                disabled={!isActive}
              >
                Reset
              </Button>
            </div>
          )}
        </div>
        <div className={classNames(styles['DTCDefinition--FormContainer'])}>
          <Form
            form={form}
            name="dtc_definition_data_form"
            onFinish={onFinish}
            layout="horizontal"
            disabled={!isActive}
          >
            <Row gutter={16}>
              <Col span={4}>
                <Form.Item
                  name="module"
                  rules={[{ required: true, message: 'Please enter a value!' }]}
                >
                  <Input
                    readOnly
                    onClick={() => handleInputClick('Module')}
                    placeholder="Module"
                    suffix={
                      selectedValues.module?.length > 0 && (
                        <span onClick={() => handleInputClear('module')}>
                          <Icon name="close" className={classNames(styles.clearIcon)} />
                        </span>
                      )
                    }
                  />
                </Form.Item>
                {selectedValues.module?.length > 0 && (
                  <span
                    className={`${classNames(styles['DTCDefinition--Placeholder'])} ${
                      styles.small
                    }`}
                  >
                    Module ({selectedValues.module?.length})
                  </span>
                )}
              </Col>

              <Col span={4}>
                <Form.Item
                  name="dtcBase"
                  rules={[{ required: true, message: 'Please enter a value!' }]}
                >
                  <Input
                    readOnly
                    onClick={() => handleInputClick('Base Dtc')}
                    placeholder="Base DTC"
                    suffix={
                      selectedValues.dtcBase?.length > 0 && (
                        <span onClick={() => handleInputClear('dtcBase')}>
                          <Icon name="close" className={classNames(styles.clearIcon)} />
                        </span>
                      )
                    }
                  />
                </Form.Item>
                {selectedValues.dtcBase?.length > 0 && (
                  <span
                    className={`${classNames(styles['DTCDefinition--Placeholder'])} ${
                      styles.small
                    }`}
                  >
                    Base Dtc ({selectedValues.dtcBase?.length})
                  </span>
                )}
              </Col>

              <Col span={4}>
                <Form.Item
                  name="faultType"
                  rules={[{ required: true, message: 'Please enter a value!' }]}
                >
                  <Input
                    readOnly
                    onClick={() => handleInputClick('Fault Type')}
                    placeholder="Fault Type"
                    suffix={
                      selectedValues.faultType?.length > 0 && (
                        <span onClick={() => handleInputClear('faultType')}>
                          <Icon name="close" className={classNames(styles.clearIcon)} />
                        </span>
                      )
                    }
                  />
                </Form.Item>
                {selectedValues.faultType?.length > 0 && (
                  <span
                    className={`${classNames(styles['DTCDefinition--Placeholder'])} ${
                      styles.small
                    }`}
                  >
                    Fault Type ({selectedValues.faultType?.length})
                  </span>
                )}
              </Col>

              <Col span={4}>
                <Form.Item
                  name="status"
                  rules={[{ required: true, message: 'Please enter a value!' }]}
                >
                  <Input
                    readOnly
                    onClick={() => handleInputClick('Status')}
                    placeholder="Status"
                    suffix={
                      selectedValues.status?.length > 0 && (
                        <span onClick={() => handleInputClear('status')}>
                          <Icon name="close" className={classNames(styles.clearIcon)} />
                        </span>
                      )
                    }
                  />
                </Form.Item>
                {selectedValues.status?.length > 0 && (
                  <span
                    className={`${classNames(styles['DTCDefinition--Placeholder'])} ${
                      styles.small
                    }`}
                  >
                    Status ({selectedValues.status?.length})
                  </span>
                )}
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <Form.Item name="dtcDecodeData" valuePropName="checked">
                  <Checkbox value={decodeData} onChange={(e) => setDecodeData(e.target.checked)}>
                    Tick box to include decoded snapshot data field in query results
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>

            {isActive && (
              <Row justify="space-between">
                <Col>
                  <Form.Item>
                    <Button
                      className={classNames(styles['DTCDefinition--Buttons'])}
                      type="primary"
                      onClick={onBack}
                    >
                      Back
                    </Button>
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item>
                    <Button
                      className={classNames(styles['DTCDefinition--Buttons'])}
                      type="primary"
                      onClick={handleNext}
                    >
                      Next
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            )}

            <Modal open={openModal} onClose={handleCancel} width={900} footer={null}>
              <div className={classNames(styles['DTCDefinition--ModalHeader'])}>
                Select {inputPlaceholder}
                {inputPlaceholder === 'Status' && <span> - {MODAL_STATUS}</span>}
              </div>
              <div className={classNames(styles['DTCDefinition--ModelContent'])}>
                <div>
                  <p className={classNames(styles['DTCDefinition--TagTitle'])}>Selection</p>
                  <div className={classNames(styles['DTCDefinition--TagsContainer'])}>
                    {sourceCheck === 'faultType'
                      ? (selectedFaultType || []).map((item: any, index: any) => {
                          return (
                            <Button
                              type="primary"
                              key={`${item}${index}`}
                              onClick={() =>
                                removeFaultType(selectedValues?.faultType[index], item)
                              }
                              className={styles['selected-button']}
                            >
                              {item}
                              <Icon
                                name="close"
                                className={`${styles['DTCDefinition--ModalDropDownIcon']} ${styles['close-icon']}`}
                              />
                            </Button>
                          );
                        })
                      : (selectedValues[sourceCheck] || []).map((item: any, index: any) => {
                          return (
                            <Button
                              type="primary"
                              key={`${item}${index}`}
                              onClick={() => handleRemove(sourceCheck, item)}
                              className={styles['selected-button']}
                            >
                              {item}
                              <Icon
                                name="close"
                                className={`${styles['DTCDefinition--ModalDropDownIcon']} ${styles['close-icon']}`}
                              />
                            </Button>
                          );
                        })}
                  </div>
                </div>
                <div className={styles['DTCDefinition--Search']}>
                  <Row gutter={16} justify="space-between">
                    <Col span={8}>
                      <div style={{ position: 'relative' }}>
                        <Input
                          name="filterValue"
                          value={searchValue}
                          onChange={(e) => setSearchValue(e.target.value)}
                          onFocus={handleModalInputFocus}
                          onBlur={handleModalInputBlur}
                          ref={inputRef} // Use ref to access the input
                        />
                        <span
                          className={`${styles['DTCDefinition--ModalInputText']} ${
                            isSmallText ? styles.small : ''
                          }`}
                          onClick={handlePlaceholderClick} // Click handler to focus the input
                        >
                          Look for {inputPlaceholder}
                        </span>
                      </div>
                    </Col>
                    <Col span={4}>
                      <Dropdown menu={{ items: moreItems }} trigger={['click']}>
                        <Button className={styles['DTCDefinition--ModalDropDown']}>
                          Limit
                          <Icon
                            name="arrow_drop_down"
                            className={styles['DTCDefinition--ModalDropDownIcon']}
                          />
                        </Button>
                      </Dropdown>
                    </Col>
                  </Row>
                </div>
                <div className={styles['DTCDefinition--SearchList']}>
                  {sourceCheck === 'module' && (
                    <List
                      itemLayout="horizontal"
                      // loading={isLoading}
                      loading={{
                        spinning: isLoading,
                        indicator: <Spin className={styles['loader-color']} />,
                      }}
                      dataSource={filteredSources}
                      renderItem={(item) => (
                        <List.Item
                          className={`${
                            selectedValues.module.includes(item.module)
                              ? styles['selected-item']
                              : styles['list-item']
                          }`}
                          onClick={() => onLinkClick('module', item.module)}
                        >
                          <span>{item.module}</span>
                        </List.Item>
                      )}
                    />
                  )}
                  {sourceCheck === 'dtcBase' && (
                    <List
                      itemLayout="horizontal"
                      loading={{
                        spinning: isLoading,
                        indicator: <Spin className={styles['loader-color']} />,
                      }}
                      dataSource={filteredSourcesDtc}
                      renderItem={(item) => (
                        <List.Item
                          className={`${
                            selectedValues.dtcBase.includes(item.dtcBase)
                              ? styles['selected-item']
                              : styles['list-item']
                          }`}
                          onClick={() => onLinkClick('dtcBase', item.dtcBase)}
                          style={{ display: 'flex', flexWrap: 'nowrap' }}
                        >
                          <div style={{ flex: 1, paddingRight: '10px' }}>
                            <span>{item.dtcBase}</span>
                          </div>

                          <div style={{ flex: 1, paddingRight: '10px' }}>
                            <span>{item.dtcHex}</span>
                          </div>

                          <div style={{ flex: 4, paddingRight: '10px', whiteSpace: 'nowrap' }}>
                            <span>{item.dtcDescription}</span>
                          </div>
                        </List.Item>
                      )}
                    />
                  )}
                  {sourceCheck === 'faultType' && (
                    <List
                      itemLayout="horizontal"
                      // loading={isLoading}
                      loading={{
                        spinning: isLoading,
                        indicator: <Spin className={styles['loader-color']} />,
                      }}
                      dataSource={filteredFaultType}
                      renderItem={(item) => (
                        <List.Item
                          className={`${
                            selectedFaultType.includes(
                              `${item.faultType} ${item.faultTypeDescription}`
                            )
                              ? styles['selected-item']
                              : styles['list-item']
                          }`}
                          onClick={() =>
                            onFaultTypeClick(
                              item.faultType,
                              `${item.faultType} ${item.faultTypeDescription}`
                            )
                          }
                        >
                          <div style={{ flex: 1, paddingRight: '10px' }}>
                            <span>{item.faultType}</span>
                          </div>
                          <div style={{ flex: 4, paddingRight: '10px', whiteSpace: 'nowrap' }}>
                            <span>{item.faultTypeDescription}</span>
                          </div>
                        </List.Item>
                      )}
                    />
                  )}
                  {sourceCheck === 'status' && (
                    <List
                      itemLayout="horizontal"
                      // loading={isLoading}
                      loading={{
                        spinning: isLoading,
                        indicator: <Spin className={styles['loader-color']} />,
                      }}
                      dataSource={filteredSourcesStatus}
                      renderItem={(item) => (
                        <List.Item
                          className={`${
                            selectedValues.status.includes(item.status)
                              ? styles['selected-item']
                              : styles['list-item']
                          }`}
                          onClick={() => onLinkClick('status', item.status)}
                        >
                          <span>{item.status}</span>
                        </List.Item>
                      )}
                    />
                  )}
                </div>
                <div className={styles['DTCDefinition--ModalPageNo']}> 1 - 4 / 4 </div>
              </div>
              <div className={styles['DTCDefinition--ModalFooter']}>
                <Space>
                  <Button onClick={handleCancel} className={styles['DTCDefinition--CancelButton']}>
                    Cancel
                  </Button>
                  <Button
                    onClick={() => applyMethod(sourceCheck)}
                    className={styles['DTCDefinition--Buttons']}
                  >
                    Apply
                  </Button>
                </Space>
              </div>
            </Modal>
          </Form>
        </div>
      </div>
    );
  }
);
DTCDefinition.displayName = 'DTCDefinition';
export default DTCDefinition;
